import { render, staticRenderFns } from "./peopleManage.vue?vue&type=template&id=00daf2f7&scoped=true&"
import script from "./peopleManage.vue?vue&type=script&lang=js&"
export * from "./peopleManage.vue?vue&type=script&lang=js&"
import style0 from "./peopleManage.vue?vue&type=style&index=0&id=00daf2f7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00daf2f7",
  null
  
)

export default component.exports